var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"blue-grey darken-4",attrs:{"width":"400","fixed":"","right":"","temporary":""},model:{value:(_vm.msg),callback:function ($$v) {_vm.msg=$$v},expression:"msg"}})}
var staticRenderFns = []

export { render, staticRenderFns }